import React from "react";
import "./about.scss";

import logosumban from "../../Media/KHI_Green.png";

const aboutsumban = () => {
  return (
    <div id="about" className="about-sumban">
      <div className="containerlogo">
        <div className="logosumban">
          <img className="gambarsumban" src={logosumban} alt="logo sumban" />
        </div>
      </div>
      <div className="containerdesk">
        <div className="judul1">
          <h1>Discover a Better Way of Living</h1>
        </div>
        <div className="desk">
          Kota Harapan Indah adalah sebuah kawasan perumahan dan kota mandiri
          yang berkembang pesat di Bekasi, Jawa Barat. Dikembangkan oleh PT
          Damai Putra Group, kawasan ini dirancang untuk menjadi hunian modern
          dengan infrastruktur yang lengkap, fasilitas unggulan, serta
          aksesibilitas yang baik bagi penghuninya. Dengan luas lebih dari 2.200
          hektare, Kota Harapan Indah menggabungkan konsep perumahan, komersial,
          pendidikan, serta ruang hijau yang menjadikannya salah satu kawasan
          hunian paling diminati di Jabodetabek.
        </div>
      </div>
    </div>
  );
};

export default aboutsumban;
